
import { useEffect } from 'react';
import emailjs from '@emailjs/browser';

// EmailJS configuration constants
export const EMAILJS_SERVICE_ID = 'service_9abvtyz';
export const EMAILJS_TEMPLATE_ID = 'template_7nlqdjh';
export const EMAILJS_PUBLIC_KEY = '5e4OrYQnbELp_0dgu';

const EmailJSInit = () => {
  useEffect(() => {
    // Initialize EmailJS
    emailjs.init(EMAILJS_PUBLIC_KEY);
    console.log('EmailJS initialized with public key');
  }, []);
  
  return null;
};

export default EmailJSInit;
